'use strict';
// var $ = require("https://code.jquery.com/jquery-3.4.1.min.js")
var $ = require('../../node_modules/jquery'),
slick = require('../../node_modules/slick-carousel');

// Asynchronous load fonts
window.WebFontConfig = {
  google: { families: ['Noto+Sans+JP:400,500,700'] },
  active: function() {
    sessionStorage.fonts = true;
  }
};

(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

$(function() {

  if($('.p-voice').length){
    $('.voiceTab li').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('.voiceTab li').removeClass('current');
      $('.voiceFilter').removeClass('current');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })

    $('.voiceFilter__link').click(function(){
      $('.voiceFilter__link').removeClass('current');
      $(this).addClass('current');
    })
  }

  $('.noticeTab li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.noticeTab li').removeClass('current');
    $('.noticeTab__content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

    // デバイス判定
  var getDevice = (function(){
    var ua = navigator.userAgent;
    if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
      return 'sp';
    }else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
      return 'tab';
    }else{
      return 'other';
    }
  })();

  if($(".p-slick").length){
    $(".p-slick").slick({
      centerMode: true,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 15000,
      cssEase: 'ease',
      dots: true,
      variableWidth: true,
      prevArrow: $('.p-slickArrow__prev'),
      nextArrow: $('.p-slickArrow__next'),
      mobileFirst:true,
      responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          dots: true,
          autoplay: true,
          infinite: true,
        }
      }]
    });
  }

  if($(".p-slick--content").length){
    $('.p-slick--content').on('init',function(){
      $('.p-slick__caption').addClass('is-fade-up');
    });
    $(".p-slick--content").slick({
      asNavFor:'.p-slick__thumbnail',
      centerMode: true,
      infinite: true,
      variableWidth: true,
      slidesToShow: 1,
      cssEase: 'ease-in-out',
      prevArrow: $('.p-slickArrow2__prev'),
      nextArrow: $('.p-slickArrow2__next'),
      mobileFirst: true,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: true,
        }
      }]
    });
    $('.p-slick__thumbnail').slick({
      asNavFor:'.p-slick--content',
      focusOnSelect: true,
      arrows: false,
      slidesToShow: 8,
      cssEase: 'ease-in-out',
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 8,
          infinite: true,
        }
      }]
    });
    $('.p-slick--content').on('beforeChange',function(){
      $('.p-slick__caption').removeClass('is-fade-up');
    });
    $('.p-slick--content').on('afterChange',function(){
      $('.p-slick__caption').addClass('is-fade-up');
    });
  }
  // smooth scroll
  $('a[href^="#"]').on('click', function(e) {
    if(!$(this).hasClass('js-list-trigger')) {
      var speed = 500,
        href= $(this).attr('href'),
        target = $(href == '#' || href == '' ? 'html' : href),
        position = target.offset().top;
      $('html, body').animate({
        scrollTop: position
      }, speed, 'swing');
      return false;
    }
    e.preventDefault();
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 150
        }, 'linear');
        return false;
      }
    }
  });

  // return top
  var returnTopBtn = $('.is-return-top-hidden'),
    btnView = 500,
    speed = 400;
  returnTopBtn.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > btnView) {
      returnTopBtn.fadeIn();
    } else {
      returnTopBtn.fadeOut();
    }
  });
  //スクロールしてトップ
  returnTopBtn.click(function () {
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });

  function fade(a) {
    $("." + a).each(function(){
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      var b = a + "-active";
      if (scroll > imgPos - windowHeight + windowHeight/5){
        $(this).addClass(b);
      } else {
        $(this).removeClass(b);
      }
    });
  }

  function fixedBanner() {
    var imgPos = $(".js-floating-start").offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height(),
        floating = $(".p-floating");
    if (scroll >= imgPos){
      floating.addClass("js-floating--fixed");
    } else {
      floating.removeClass("js-floating--fixed");
    }
  }

  function fixedHeader() {
    var navPos = $(".js-header-start").offset().top + 10,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height(),
        header = $(".js-header"),
        nav = $("nav"),
        main = $("main"),
        headerHeight = header.outerHeight();
    if (scroll >= headerHeight && scroll <= navPos) {
      header.addClass("is-none");
    } else {
      header.removeClass("is-none");
    }
    if (scroll >= navPos) {
      header.addClass("is-fixed");
      main.css("margin-top", headerHeight);
    } else {
      header.removeClass("is-fixed");
      main.css("margin-top", 0);
    }
  }

  $(window).on("load scroll", function(){
    fade("u-fade-in");
    fade("u-fade-up");

    $(".js-floating").css("left", -$(window).scrollLeft());

    fixedBanner();
    fixedHeader();
  });

  $(".l-header__menu-img").click(function (){
    $(".l-header").toggleClass("js-nav--active");
    if(!$('.l-header').hasClass('js-nav--active')) {
      $('.l-nav__dropdown').removeClass('active');
    }
  });

  $('.p-price__inclusions-title').each(function(){
    var a = $(this);
    a.click(function(e){
      a.toggleClass('p-price__accordion-active');
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
  });

  $('.p-education__image-btn').click(function(){
    var msg = $(this).parent().next().find('.p-education__info-btn-msg');
    $(this).toggleClass('js-btn-rev');
    msg.toggleClass('js-btn-msg-active');

    // CHANGE INNER TEXT WHEN メッセージ is open/close.
    if(msg.hasClass('js-btn-msg-active')) {
      $(this).text('メッセージを閉じる');
    }
    else {
      $(this).text('メッセージを見る');
    }
  });

  $(".js-inner-link").each(function(){
    var _ = $(this),
        header = $(".l-header");
    _.click(function(e){
      if(header.hasClass("js-nav--active")){
        header.removeClass("js-nav--active");
      }
    });
  });
  if (getDevice === 'sp') {
    $('.js-accordion-header').on('click', function(){
      $(this).toggleClass('c-triangle-down--menu').next().slideToggle(300);
    });
  }



  $('.p-services__btn').click(function(){
    $('.js-services-list').slideToggle(1000);
    if($('.js-services-list').hasClass('accordion-active')) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#services-start").offset().top - $(window).height() +  ($(window).height() * 0.2)
      }, 1000);
    }
    $('.js-services-list').toggleClass('accordion-active');
  });

  $('.c-accordion').click(function() {
    $(this).toggleClass('js-accordion-active');
  });

  $('.c-accordion-custom').click(function() {
    $(this).toggleClass('js-accordion-custom-active');
  });

  //SP OF QUALITY SECTIOM
  $('.p-quality-sp__tag').click(function() {
    $(this).next().slideToggle();
  });

  $('.js-tabbutton').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.js-tabbutton').removeClass('p-lesson__sp-tabbuttons-li--active');
    $('.js-content-triiger').removeClass('p-lesson__sp-table-timesheet-ritem--current');
    $(this).addClass('p-lesson__sp-tabbuttons-li--active');
    $("#"+tab_id).addClass('p-lesson__sp-table-timesheet-ritem--current');
  });

  if (getDevice === 'sp') {
    for(var x=0; x<$(".p-nav__nav-container").length;x++)
    $(".p-nav__nav-container").eq(x).attr('src','/images/service/nav-img' + x + 1 + '-sp.jpg')
  }

  var tableTab = 0;
  $('.p-quality__tabs-tab').click(function(){

    // tableTab == index of tab that is clicked
    tableTab = $(this).index();
    $(this).addClass('js-tab-active');

    // if tab-2/tab-3 is clicked, add left white border. else, remove left white border.
    if (tableTab == 0)
      $(".p-quality__table .p-quality__tabs").removeClass('js-quality-leftborderwhite');
    else
      $(".p-quality__table .p-quality__tabs").addClass('js-quality-leftborderwhite');

    $(".p-quality__tabs-tab").not(":eq(" + tableTab + ")").removeClass("js-tab-active");
    //change background of content using this code
    var bg = "js-quality-bg" + (tableTab + 1);
    if (tableTab == 0)
      bg = "";

    $('.p-quality__content').removeClass("js-quality-bg1 js-quality-bg2 js-quality-bg3").addClass(bg);

    //change the content of the div depending on which tab is clicked
    for(var x = 1; x <= $('.p-quality__content-text').length; x++) {
      if (x == (tableTab + 1))
        $('.quality-' + x).show();
      else
        $('.quality-' + x).hide();
    }
  });


  $('.js-learning-course__tab').on('click', function(){
    var tabClicked = $(this).index();

    $(".js-learning-course__tab").removeClass("is-active");
    $(this).addClass('is-active');
    $(".js-learning-course__target").addClass('not-active u-fade-in-active');
    $(".js-learning-course__target").eq(tabClicked).removeClass('not-active').show();

  });

  if (getDevice === 'sp') {
    var slideCurrent = 0,
        slideNoticeCurrent = 0,
        slideWidth = $('.js-learning-course__tab').outerWidth(true),
        slideNum = $('.js-learning-course__tab').length,
        slideNoticeWidth = $('.noticeTab__link').outerWidth(true),
        slideNoticeNum = $('.noticeTab__link').length,
        slideSetWidth = slideWidth * slideNum,
        slideVW = (100 / 768) * slideSetWidth + 'vw',
        slideSetNoticeWidth = slideNoticeWidth * slideNoticeNum,
        is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    $('.js-couse-tab').css('width', slideSetWidth);
    $('.js-notice-tab').css('width', slideSetNoticeWidth);

    var dynamicHeight2 = $(".noticeTab__content.current ul").height();

    $(".noticeTab__wrapper").css("height", dynamicHeight2);
    var sliding = function(){
      if(slideCurrent < 0){
        slideCurrent = slideNum - 1;
      }else if(slideCurrent > slideNum - 1 ) {
        slideCurrent = 0;
      }
      if (slideNoticeCurrent < 0){
        slideNoticeCurrent = slideNoticeNum - 1;
      } else if(slideNoticeCurrent > slideNoticeNum - 1 ) {
        slideNoticeCurrent = 0;
      }
      var courseWidth = slideCurrent * -slideWidth,
        coursewv = (100 / slideWidth) * courseWidth + 'vw';
      if(is_safari) {
        $('.js-notice-content').stop().animate({
          left: slideNoticeCurrent * -slideNoticeWidth
        });
        $('.js-notice-tab').stop().animate({
          left: slideNoticeCurrent * -slideNoticeWidth
        });
        $('.js-course-content').stop().animate({
          left: slideCurrent * -$('.js-learning-course__target').width()
        });
        $('.js-couse-tab').stop().animate({
          left: slideCurrent * -100 + 'vw'
        });
      } else {
        $('.js-notice-content').stop().animate({
          left: slideNoticeCurrent * -slideNoticeWidth
        });
        $('.js-notice-tab').stop().animate({
          left: slideNoticeCurrent * -slideNoticeWidth
        });
        $('.js-course-content').stop().animate({
          left: coursewv
        });
        $('.js-couse-tab').stop().animate({
          left: slideCurrent * -100 + 'vw'
        });
      }

      // COURSE
      $(".p-learning-course__tabs-li:nth-child(" + (slideCurrent + 1) + ")").addClass("is-active");
      if($(".p-learning-course__tabs-li").hasClass("is-active")) {
        $(".p-learning-course__tabs-li:nth-child(" + (slideCurrent) + ")").removeClass("is-active");
      }
      // TOP NOTICE
      
      $(".noticeTab__content:nth-child(" + (slideNoticeCurrent + 1) + ")").addClass("js-notice-active");
      $(".noticeTab__link:nth-child(" + (slideNoticeCurrent + 1) + ")").addClass("current");
      if($(".noticeTab__link").hasClass("current")) {
        $(".noticeTab__link:nth-child(" + (slideNoticeCurrent) + ")").removeClass("current");
        $(".noticeTab__content:nth-child(" + (slideNoticeCurrent) + ")").removeClass("js-notice-active");
      }

      var ab_no = $(".noticeTab__link.current").attr('data-tab'),
      dynamicHeight = $("#"+ ab_no + ".js-notice-active .noticeLists").height();

      $(".noticeTab__wrapper").css("height", dynamicHeight);
      
    }

    $('.js-course-left').on('touchstart click', function(event){
      event.preventDefault();
      slideCurrent--;
      slideNoticeCurrent--;
      sliding();
    });
    $('.js-course-right').on('touchstart click', function(event){
      event.preventDefault();
      slideCurrent++;
      slideNoticeCurrent++;
      sliding();
    });
  }
  var date1 = document.querySelector('input[name="date1"]');
var time1 = document.querySelector('.time1 select');
var date2 = document.querySelector('input[name="date2"]');
var time2 = document.querySelector('.time2 select');
var date3 = document.querySelector('input[name="date3"]');
var time3 = document.querySelector('.time3 select');
time1.disabled = true;
time2.disabled = true;
time3.disabled = true;
date3.disabled = true;
date1.onchange = function(){
    time1.disabled = false;
    var dateString = date1.value;
    var myDate = new Date(dateString).toString().replace(/ .*/, '');
    if(myDate === "Sat") {
        document.querySelector('.time1 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time1 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time1 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time1 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time1 option[value="21:10 ~ 22:00"]').disabled = true;
    } else if(myDate === "Sun") {
        document.querySelector('.time1 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time1 option[value="9:10 ~ 10:00"]').disabled = true;
        document.querySelector('.time1 option[value="10:10 ~ 11:00"]').disabled = true;
        document.querySelector('.time1 option[value="11:10 ~ 12:00"]').disabled = true;
        document.querySelector('.time1 option[value="12:10 ~ 13:00"]').disabled = true;
        document.querySelector('.time1 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time1 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time1 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time1 option[value="21:10 ~ 22:00"]').disabled = true;
    }
    if(date1.value.length > 0 && date2.value.length > 0) {
      date3.disabled = false;
    }
};
date2.onchange = function(){
    time2.disabled = false;
    var dateString = date2.value;
    var myDate = new Date(dateString).toString().replace(/ .*/, '');
    if(myDate === "Sat") {
        document.querySelector('.time2 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time2 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time2 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time2 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time2 option[value="21:10 ~ 22:00"]').disabled = true;
    } else if(myDate === "Sun") {
        document.querySelector('.time2 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time2 option[value="9:10 ~ 10:00"]').disabled = true;
        document.querySelector('.time2 option[value="10:10 ~ 11:00"]').disabled = true;
        document.querySelector('.time2 option[value="11:10 ~ 12:00"]').disabled = true;
        document.querySelector('.time2 option[value="12:10 ~ 13:00"]').disabled = true;
        document.querySelector('.time2 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time2 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time2 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time2 option[value="21:10 ~ 22:00"]').disabled = true;
    }
    if(date1.value.length > 0 && date2.value.length > 0) {
      date3.disabled = false;
    }
};
date3.onchange = function(){
    time3.disabled = false;
    var dateString = date3.value;
    var myDate = new Date(dateString).toString().replace(/ .*/, '');
    if(myDate === "Sat") {
        document.querySelector('.time3 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time3 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time3 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time3 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time3 option[value="21:10 ~ 22:00"]').disabled = true;
    } else if(myDate === "Sun") {
        document.querySelector('.time3 option[value="8:10 ~ 9:00"]').disabled = true;
        document.querySelector('.time3 option[value="9:10 ~ 10:00"]').disabled = true;
        document.querySelector('.time3 option[value="10:10 ~ 11:00"]').disabled = true;
        document.querySelector('.time3 option[value="11:10 ~ 12:00"]').disabled = true;
        document.querySelector('.time3 option[value="12:10 ~ 13:00"]').disabled = true;
        document.querySelector('.time3 option[value="18:10 ~ 19:00"]').disabled = true;
        document.querySelector('.time3 option[value="19:10 ~ 20:00"]').disabled = true;
        document.querySelector('.time3 option[value="20:10 ~ 21:00"]').disabled = true;
        document.querySelector('.time3 option[value="21:10 ~ 22:00"]').disabled = true;
    }
};
// Apply Form
checkboxes = document.querySelectorAll('.learning input[type="checkbox"]'); 
limit = 0;
function checker(elem) {
  if (elem.checked) { 
    limit++;
  } else {
    limit--; 
  }
  for (i = 0; i < checkboxes.length; i++) {

    if (limit == 2) {
      if (!checkboxes[i].checked) {
        checkboxes[i].disabled = true;
      }
    } else { 
      if (!checkboxes[i].checked) {
        checkboxes[i].disabled = false;
      }
    }
  }
}

for (i = 0; i < checkboxes.length; i++) {
  checkboxes[i].onclick = function() { 
    checker(this);
  }
}

var formTexts = jQuery('.wpcf7-checkbox.learning span span');
Object.keys(formTexts).filter(function(key) {
    if(!isNaN(Number(key))) {
        var replace = formTexts[key].innerHTML.split("：").pop();
        formTexts[key].innerHTML = replace;
    } 
});

// var todayDate = new Date().toISOString().slice(0,10);
// date1.min = todayDate;
// date2.min = todayDate;
// date3.min = todayDate;

$('.l-nav__dropdown').on('click', function(e) {
  // e.preventDefault(e);
  var _ = $(this);
  _.toggleClass('active');
});


});

(function() {
  $('.l-nav__dropdown').on('click', function(e) {
    // e.preventDefault(e);
    var _ = $(this);
    _.toggleClass('active');
  });
  $('.company__group-training a').on('click', function() {
    $(".company__group-training a[target!='_blank'][href$='.pdf']").attr("target", "_blank");
  });
 
})();